/**
 * Slow Socks · comportamientos globales mínimos (se carga en todas las páginas desde theme.liquid).
 * - Tarjeta de producto: en escritorio, al pasar por una miniatura de color se ve esa foto en grande;
 *   al salir de las miniaturas vuelve la original. Solo con ratón (hover: hover).
 */
const conRaton = window.matchMedia('(hover: hover) and (pointer: fine)');

/** @param {Element} tarjeta */
function fotoDe(tarjeta) {
  return /** @type {HTMLImageElement | null} */ (tarjeta.querySelector('.ss-tarjeta__img'));
}

document.addEventListener('pointerover', (e) => {
  if (!conRaton.matches || !(e.target instanceof Element)) return;
  const enlace = e.target.closest('.ss-tarjeta__colores [data-ss-color]');
  if (!enlace) return;
  const tarjeta = enlace.closest('.ss-tarjeta');
  const img = tarjeta && fotoDe(tarjeta);
  if (!img) return;
  if (!img.dataset.ssOriginalSrc) {
    img.dataset.ssOriginalSrc = img.currentSrc || img.src;
    img.dataset.ssOriginalSrcset = img.getAttribute('srcset') || '';
  }
  const url = enlace.getAttribute('data-ss-color');
  if (url) {
    img.removeAttribute('srcset');
    img.src = url;
  }
});

document.addEventListener('pointerout', (e) => {
  if (!(e.target instanceof Element)) return;
  const lista = e.target.closest('.ss-tarjeta__colores');
  if (!lista || (e.relatedTarget instanceof Node && lista.contains(e.relatedTarget))) return;
  const tarjeta = lista.closest('.ss-tarjeta');
  const img = tarjeta && fotoDe(tarjeta);
  if (!img || !img.dataset.ssOriginalSrc) return;
  if (img.dataset.ssOriginalSrcset) img.setAttribute('srcset', img.dataset.ssOriginalSrcset);
  img.src = img.dataset.ssOriginalSrc;
});

/* ── Carrito: el foco no se pierde al cambiar la cantidad (WCAG 2.4.3) ──────────────────────────────────
   Al pulsar + / − / Quitar en una línea, o el + del empujón, Horizon vuelve a pintar el carrito y el botón
   que tenía el foco puede desaparecer: el foco caía en <body>. Se vigila hasta 8 s y, si se pierde, se
   devuelve al mismo control de la misma línea (o al más parecido que quede). */
const SS_CONTROLES = ['quantity-plus', 'quantity-minus', 'cart-items__remove', 'ss-mini__mas'];
const SS_ZONA_CARRITO = '#cart-drawer, cart-items-component, .cart-page';

document.addEventListener(
  'click',
  (e) => {
    if (!(e.target instanceof Element)) return;
    const control = e.target.closest(SS_CONTROLES.map((c) => '.' + c).join(','));
    if (!control || !control.closest(SS_ZONA_CARRITO)) return;
    const clase = SS_CONTROLES.find((c) => control.classList.contains(c));
    const clave = control.closest('[data-key]')?.getAttribute('data-key') || null;
    const enCajon = Boolean(control.closest('#cart-drawer'));
    const inicio = Date.now();

    const buscar = () => {
      const raiz = (enCajon ? document.getElementById('cart-drawer') : document.querySelector('cart-items-component')) || document;
      const fila = clave ? `[data-key="${CSS.escape(clave)}"]` : null;
      const enfocable = ':is(button, a[href], input:not([type="hidden"])):not([disabled]):not([tabindex="-1"])';
      const candidatos = [
        fila && `${fila} .${clase}`,
        fila && `${fila} .quantity-selector ${enfocable}`,
        fila && `${fila} ${enfocable}`,
        `.${clase}`,
        `.cart-items__table ${enfocable}`,
        '.theme-drawer__close-button, .cart-drawer__close-button--empty',
      ].filter(Boolean);
      for (const s of candidatos) {
        for (const el of raiz.querySelectorAll(/** @type {string} */ (s))) {
          if (el instanceof HTMLElement && !el.matches(':disabled') && el.getClientRects().length) return el;
        }
      }
      return null;
    };

    // Horizon puede repintar dos veces (primero desactiva el control, luego sustituye la fila): se sigue
    // vigilando hasta 8 s mientras el foco esté dentro del carrito, y se para si la persona lo lleva fuera.
    const vigilar = () => {
      const activo = document.activeElement;
      const perdido = !activo || activo === document.body || activo === document.documentElement || !activo.isConnected;
      if (perdido) {
        buscar()?.focus({ preventScroll: true });
      } else if (!activo.closest(SS_ZONA_CARRITO)) {
        return; // la persona ya ha movido el foco fuera del carrito
      }
      if (Date.now() - inicio < 8000) setTimeout(vigilar, 100);
    };
    setTimeout(vigilar, 100);
  },
  true
);

/* ── Página de carrito en el móvil: barra fija con el total y "Tramitar pedido" ────────────────────────
   Se enseña mientras el resumen del carrito queda por debajo de la pantalla (blocks/_cart-summary.liquid). */
if (document.querySelector('.cart-page')) {
  let ssPendiente = false;
  const ssActualizar = () => {
    ssPendiente = false;
    const barra = document.querySelector('[data-ss-pago-fijo]');
    const resumen = document.querySelector('.cart-page__summary');
    if (!barra || !resumen) return;
    const visible = resumen.getBoundingClientRect().top > window.innerHeight - 24;
    barra.classList.toggle('ss-pago-fijo--visible', visible);
  };
  const ssPedir = () => {
    if (ssPendiente) return;
    ssPendiente = true;
    requestAnimationFrame(ssActualizar);
  };
  window.addEventListener('scroll', ssPedir, { passive: true });
  window.addEventListener('resize', ssPedir);
  const ssCarrito = document.querySelector('cart-items-component');
  if (ssCarrito) new MutationObserver(ssPedir).observe(ssCarrito, { childList: true, subtree: true });
  ssActualizar();
}
